import { render } from "./CardKanban.vue?vue&type=template&id=08607330&scoped=true&ts=true"
import script from "./CardKanban.vue?vue&type=script&lang=ts"
export * from "./CardKanban.vue?vue&type=script&lang=ts"

import "./CardKanban.vue?vue&type=style&index=0&id=08607330&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08607330"]])

export default __exports__